var endpointMap = {
	ar: {
		"roots.footer": "translation-ar.json",
		"roots.header": "translation-ar.json"
	},
	"ar-AE": {
		"roots.footer": "translation-ar.json",
		"roots.header": "translation-ar.json"
	},
	bn: {
		"roots.footer": "translation-bn.json",
		"roots.header": "translation-bn.json"
	},
	"bn-IN": {
		"roots.footer": "translation-bn.json",
		"roots.header": "translation-bn.json"
	},
	cs: {
		"roots.footer": "translation-cs.json",
		"roots.header": "translation-cs.json"
	},
	"cs-CZ": {
		"roots.footer": "translation-cs.json",
		"roots.header": "translation-cs.json"
	},
	de: {
		"roots.footer": "translation-de.json",
		"roots.header": "translation-de.json"
	},
	"de-DE": {
		"roots.footer": "translation-de.json",
		"roots.header": "translation-de.json"
	},
	en: {
		"roots.footer": "translation-en.json",
		"roots.header": "translation-en.json"
	},
	"en-US": {
		"roots.footer": "translation-en.json",
		"roots.header": "translation-en.json"
	},
	es: {
		"roots.footer": "translation-es.json",
		"roots.header": "translation-es.json"
	},
	"es-ES": {
		"roots.footer": "translation-es.json",
		"roots.header": "translation-es.json"
	},
	"es-MX": {
		"roots.footer": "translation-es.json",
		"roots.header": "translation-es.json"
	},
	"es-US": {
		"roots.footer": "translation-es.json",
		"roots.header": "translation-es.json"
	},
	fr: {
		"roots.footer": "translation-fr.json",
		"roots.header": "translation-fr.json"
	},
	"fr-BE": {
		"roots.footer": "translation-fr.json",
		"roots.header": "translation-fr.json"
	},
	"fr-CA": {
		"roots.footer": "translation-fr.json",
		"roots.header": "translation-fr.json"
	},
	"fr-FR": {
		"roots.footer": "translation-fr.json",
		"roots.header": "translation-fr.json"
	},
	hi: {
		"roots.footer": "translation-hi.json",
		"roots.header": "translation-hi.json"
	},
	"hi-IN": {
		"roots.footer": "translation-hi.json",
		"roots.header": "translation-hi.json"
	},
	it: {
		"roots.footer": "translation-it.json",
		"roots.header": "translation-it.json"
	},
	"it-IT": {
		"roots.footer": "translation-it.json",
		"roots.header": "translation-it.json"
	},
	ja: {
		"roots.footer": "translation-ja.json",
		"roots.header": "translation-ja.json"
	},
	"ja-JP": {
		"roots.footer": "translation-ja.json",
		"roots.header": "translation-ja.json"
	},
	km: {
		"roots.footer": "translation-km.json",
		"roots.header": "translation-km.json"
	},
	"km-KH": {
		"roots.footer": "translation-km.json",
		"roots.header": "translation-km.json"
	},
	kn: {
		"roots.footer": "translation-kn.json",
		"roots.header": "translation-kn.json"
	},
	"kn-IN": {
		"roots.footer": "translation-kn.json",
		"roots.header": "translation-kn.json"
	},
	mr: {
		"roots.footer": "translation-mr.json",
		"roots.header": "translation-mr.json"
	},
	"mr-IN": {
		"roots.footer": "translation-mr.json",
		"roots.header": "translation-mr.json"
	},
	pl: {
		"roots.footer": "translation-pl.json",
		"roots.header": "translation-pl.json"
	},
	"pl-PL": {
		"roots.footer": "translation-pl.json",
		"roots.header": "translation-pl.json"
	},
	pt: {
		"roots.footer": "translation-pt.json",
		"roots.header": "translation-pt.json"
	},
	"pt-BR": {
		"roots.footer": "translation-pt.json",
		"roots.header": "translation-pt.json"
	},
	"pt-PT": {
		"roots.footer": "translation-pt.json",
		"roots.header": "translation-pt.json"
	},
	si: {
		"roots.footer": "translation-si.json",
		"roots.header": "translation-si.json"
	},
	"si-LK": {
		"roots.footer": "translation-si.json",
		"roots.header": "translation-si.json"
	},
	sk: {
		"roots.footer": "translation-sk.json",
		"roots.header": "translation-sk.json"
	},
	"sk-SK": {
		"roots.footer": "translation-sk.json",
		"roots.header": "translation-sk.json"
	},
	ta: {
		"roots.footer": "translation-ta.json",
		"roots.header": "translation-ta.json"
	},
	"ta-IN": {
		"roots.footer": "translation-ta.json",
		"roots.header": "translation-ta.json"
	},
	te: {
		"roots.footer": "translation-te.json",
		"roots.header": "translation-te.json"
	},
	"te-IN": {
		"roots.footer": "translation-te.json",
		"roots.header": "translation-te.json"
	},
	tr: {
		"roots.footer": "translation-tr.json",
		"roots.header": "translation-tr.json"
	},
	"tr-TR": {
		"roots.footer": "translation-tr.json",
		"roots.header": "translation-tr.json"
	},
	und: {
		"roots.footer": "translation.json",
		"roots.header": "translation.json"
	},
	vi: {
		"roots.footer": "translation-vi.json",
		"roots.header": "translation-vi.json"
	},
	"vi-VN": {
		"roots.footer": "translation-vi.json",
		"roots.header": "translation-vi.json"
	},
	zh: {
		"roots.footer": "translation-zh.json",
		"roots.header": "translation-zh.json"
	},
	"zh-CN": {
		"roots.footer": "translation-zh.json",
		"roots.header": "translation-zh.json"
	},
	"zh-TW": {
		"roots.footer": "translation-zh.json",
		"roots.header": "translation-zh.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
